// 条件オブジェクト
export class Cond1 {
    constructor(
        clientType = '',
        selfSignup = false,
        highStress = false,
    ) {
        this.ClientType = clientType;
        this.SelfSignup = selfSignup;
        this.HighStress = highStress;
    }
}

export class Cond2 {
    constructor(
        highStress = false,
    ) {
        this.HighStress = highStress;
    }
}

// 月次レポート（利用実績）リクエスト
export class MonrepcngRequest {
    constructor(
        monthStart = '',
        monthEnd = '',
        organizationPk = '',
        unit = '',
        cond = new Cond1(),
        groupingTypes = []
    ) {
        this.MonthStart = monthStart;
        this.MonthEnd = monthEnd;
        this.OrganizationPk = organizationPk;
        this.Unit = unit;
        this.Cond = cond;
        this.GroupingTypes = groupingTypes;
    }

    // 初期化を返すメソッド
    getDefaultState() {
        return {
            MonthStart: '',
            MonthEnd: '',
            OrganizationPk: '',
            Unit: '',
            Cond: {
                ClientType: '',
                SelfSignup: false,
                HighStress: false
            },
            GroupingTypes: []
        }
    }

    // 状態を初期化するメソッド
    resetState() {
        Object.assign(this, this.getDefaultState())
    }

}

// 月次レポート（利用実績 イシュー別）リクエスト
export class MonrepcngisuRequest {
    constructor(
        monthStart = '',
        monthEnd = '',
        organizationPk = '',
        unit = '',
        cond = new Cond2(),
        groupingTypes = []
    ) {
        this.MonthStart = monthStart;
        this.MonthEnd = monthEnd;
        this.OrganizationPk = organizationPk;
        this.Unit = unit;
        this.Cond = cond;
        this.GroupingTypes = groupingTypes;
    }

    // 初期化を返すメソッド
    getDefaultState() {
        return {
            MonthStart: '',
            MonthEnd: '',
            OrganizationPk: '',
            Unit: '',
            Cond: {
                HighStress: false
            },
            GroupingTypes: []
        }
    }

    // 状態を初期化するメソッド
    resetState() {
        Object.assign(this, this.getDefaultState())
    }
}